<template>
  <div class="filter-control service-filters">
    <!-- spusti sa po dokonceni tasku BN - 1256 -->
    <!-- <div class="master-filter drop hideSmartphone">
      <div class="dropdown-title">Zobraziť zmluvy za mesiac</div>
      <div data-hover="false" data-delay="0" class="dropdown w-dropdown">
        <b-dropdown
          ref="dropdown-filters"
          size="sm"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template #button-content>
            <div class="w-dropdown-toggle">
              <div class="icon w-icon-dropdown-toggle"></div>
              <div class="dropdown-placeholder">
                {{ monthsFilter.active.name }}
              </div>
            </div>
          </template>
          <b-dropdown-item
            class="drop"
            :class="[monthsFilter.active === item ? 'active-filter' : '']"
            href="#"
            v-for="(item, key) in monthsFilter.inDropdown"
            :key="key"
            @click="filterPeriod(item)"
          >
            <div class="text-block-4 fnt-13" id="inspectionsFor">
              {{ item.name }}
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div> -->
    <filter-by-employee
      v-if="getRole() === 'alex_admin'"
      :label="'bankár'"
      :employees="brokersGetter"
      @employee-filter-change="$emit('broker-filter-change', $event)"
    />
    <search-by-key @filter-client-by-key="$emit('filter-client', $event)"/>
    <div class="service-view-switch" role="group" aria-label="Zobrazenie klientov v Servise">
      <button type="button" :aria-pressed="!opportunitiesOnly" :class="{'is-active': !opportunitiesOnly}" @click="$emit('opportunity-filter-change', false)">Všetci</button>
      <button type="button" :aria-pressed="opportunitiesOnly" :class="{'is-active': opportunitiesOnly}" title="Klienti s možnou úsporou aspoň 20 € mesačne" @click="$emit('opportunity-filter-change', true)">S úsporou <span>20 €+/mes.</span></button>
    </div>
  </div>
</template>

<script>
import SearchByKey from "@/components/shared/FilterResults/SearchByKey.vue";
import FilterByEmployee from "@/components/shared/FilterResults/FilterByEmployee.vue";
import {mapGetters} from "vuex";

export default {
  name: "ServisFilterBar",
  components: {SearchByKey, FilterByEmployee},
  props: {opportunitiesOnly: {type: Boolean, default: false}},
  created() {
    this.constructMonthsDropdown()
  },
  computed: {
    ...mapGetters({
      brokersGetter: "clientState/getFinancnici",
    }),
  },
  data() {
    return {
      monthsFilter: {
        inDropdown: [],
        active: null,
      },
    }
  },
  methods: {
    filterPeriod(period) {
      this.monthsFilter.active = period;
      this.$emit("period-filter-change", period.value);
    },
    getRole() {
      return this.$store.getters["userState/getRole"];
    },
    constructMonthsDropdown() {
      const currentYear = new Date().getFullYear();

      const formatDate = (date) => {
        return date.toLocaleDateString('sk-SK', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      };

      const monthsSK = Array.from({ length: 12 }, (_, i) => {
        const firstDay = new Date(currentYear, i, 1);
        const lastDay = new Date(currentYear, i + 1, 0);
        const monthName = new Intl.DateTimeFormat('sk-SK', { month: 'long' }).format(firstDay);

        return {
          name: monthName,
          value: [formatDate(firstDay).split(" ").join(""), formatDate(lastDay).split(" ").join("")]
        };
      });

      this.monthsFilter = {
        options: [{name: "všetko", value: ["", ""]}, ...monthsSK],
        active: {name: "všetko", value: ["", ""]},
      }
    }
  },
}
</script>

<style scoped>
.service-filters {display:flex; align-items:center; flex-wrap:wrap; gap:16px 24px; width:100%;}
.service-view-switch {display:inline-flex; align-items:stretch; padding:4px; gap:4px; border:1px solid rgba(255,255,255,.28); border-radius:12px; background:rgba(8,31,65,.18); flex-shrink:0;}
.service-view-switch button {appearance:none; border:0; background:transparent; color:#fff; border-radius:8px; padding:9px 14px; font:inherit; font-size:13px; line-height:20px; cursor:pointer; white-space:nowrap;}
.service-view-switch button.is-active {background:#fff; color:#194b7e; box-shadow:0 2px 6px rgba(0,0,0,.12);}
.service-view-switch button:not(.is-active):hover {background:rgba(255,255,255,.12);}
.service-view-switch button:focus-visible {outline:2px solid #fff; outline-offset:2px;}
.service-view-switch span {font-size:11px; margin-left:4px;}
@media(max-width:600px) {.service-view-switch {width:100%;} .service-view-switch button {flex:1;}}
</style>